import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";
import { BsGithub, BsEye } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import bestBike from '../../images/project-images/6.png';
import abroadPortals from '../../images/project-images/9.jpg';
import jobHunter from '../../images/project-images/10.png';
import jobNexus from '../../images/project-images/11.png';
import bestBike1 from '../../images/project-images/8.png';
import creativeCaptures from '../../images/project-images/2.png';
import quizmania from '../../images/project-images/7.png';
import learnerAcademy from '../../images/project-images/1.png';
import dailyTasks from '../../images/project-details/daily-tasks/1.png';
import './Projects.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link, useLocation } from 'react-router-dom';
import AllProjects from '../AllProjects/AllProjects';





import AbroadPortalsLarge from '../../images/projects-large-image/AbroadPortals.png';
import DoctorsPortalLarge from '../../images/projects-large-image/DoctorsPortal.png';
import BestBikesLarge from '../../images/projects-large-image/BestBikes.png';
import CreativeCapturesLarge from '../../images/projects-large-image/CreativeCaptures.png';
import LearnerAcademyLarge from '../../images/projects-large-image/LearnerAcademy.png';
import QuizManiaLarge from '../../images/projects-large-image/QuizMania1.png';
import useTitle from '../../Hooks/useTitle';
import { useLanguage } from '../../context/LanguageContext';



SwiperCore.use([Autoplay, Pagination]);










const Projects = () => {


    useTitle('Projects | Fahim Faysal')


    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])






    //Abroad Portals card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const abroadPortalsDivStyle = {
        backgroundImage: ` url(${AbroadPortalsLarge})`,
        transition: 'ease-in 8s',
    };
    const abroadPortalsHandleHover = () => {
        abroadPortalsDivStyle.transition = 'ease 8s';
    };
    const abroadPortalsHandleUnHover = () => {
        abroadPortalsDivStyle.transition = 'ease 1s'
    };


    //Doctors Portal card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const doctorsPortalDivStyle = {
        backgroundImage: ` url(${DoctorsPortalLarge})`,
        transition: 'ease-in 7s',
    };
    const doctorsPortalHandleHover = () => {
        doctorsPortalDivStyle.transition = 'ease 7s';
    };
    const doctorsPortalHandleUnHover = () => {
        doctorsPortalDivStyle.transition = 'ease 1s'
    };




    //Best Bikes card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const bestBikesDivStyle = {
        backgroundImage: ` url(${BestBikesLarge})`,
        transition: 'ease-in 5s',
    };
    const bestBikesHandleHover = () => {
        bestBikesDivStyle.transition = 'ease 5s';
    };
    const bestBikesHandleUnHover = () => {
        bestBikesDivStyle.transition = 'ease 1s'
    };



    //Creative Captures card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const creativeCapturesDivStyle = {
        backgroundImage: ` url(${CreativeCapturesLarge})`,
        transition: 'ease-in 5s',
    };
    const creativeCapturesHandleHover = () => {
        creativeCapturesDivStyle.transition = 'ease 5s';
    };
    const creativeCapturesHandleUnHover = () => {
        creativeCapturesDivStyle.transition = 'ease 1s'
    };



    // Learner Academy card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const learnerAcademyDivStyle = {
        backgroundImage: ` url(${LearnerAcademyLarge})`,
        transition: 'ease-in 4s',
    };
    const learnerAcademyHandleHover = () => {
        learnerAcademyDivStyle.transition = 'ease 4s';
    };
    const learnerAcademyHandleUnHover = () => {
        learnerAcademyDivStyle.transition = 'ease 1s'
    };



    // Quiz Mania card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const quizManiaDivStyle = {
        backgroundImage: ` url(${QuizManiaLarge})`,
        transition: 'ease-in 5s',
    };
    const quizManiaHandleHover = () => {
        quizManiaDivStyle.transition = 'ease 5s';
    };
    const quizManiaHandleUnHover = () => {
        quizManiaDivStyle.transition = 'ease 1s'
    };




    const { pathname } = useLocation();


    const { language } = useLanguage();









    return (
        <div className='mb-12 ' id='projects'>

            {
                language === 'english' ?
                    <>
                        <h1 className={`uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono  ${pathname.includes('projects') ? 'sm:mt-10 md:mt-32 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>Top
                            <span className='ml-4 md:text-6xl text-5xl text-rose-600'>
                                Projects
                            </span>
                            {/* <hr className='mx-auto mt-4 ' width="180px" /> */}
                            <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[350px] md:w-[340px] sm:w-[260px] w-[260px] h-[70px]       wavy'></div>
                        </h1>
                    </>
                    :
                    <>
                        <h1 className={`uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono  ${pathname.includes('projects') ? 'sm:mt-10 md:mt-32 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>শীর্ষ
                            <span className='ml-4 md:text-6xl text-5xl text-rose-600'>
                                প্রজেক্ট
                            </span>
                            {/* <hr className='mx-auto mt-4 ' width="180px" /> */}
                            <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[350px] md:w-[340px] sm:w-[260px] w-[260px] h-[70px]       wavy'></div>
                        </h1>
                    </>
            }





            <div className=' lg:mx-[70px] md:mx-1 mx-0' >

                <Swiper
                    // spaceBetween={10}
                    // slidesPerView={3}

                    pagination={{
                        // type: "progressbar",
                        clickable: true
                    }}

                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 50,
                        },
                    }}
                    // modules={[Pagination, Navigation]}
                    // modules={[Navigation]}
                    // navigation={true}
                    modules={[Pagination, Autoplay, Navigation]}
                    autoplay={{ delay: 1500 }}
                    className="mySwiper"
                >









                    {/* hover korle content show korbe animated hoye like abroad portals country list */}
                    {/* <SwiperSlide>
                        <div className="mb-8 card card-compact bg-base-100 shadow-xxl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2 border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0  animation                    " data-aos='flip-left'>
                            <div className='lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0  mx-auto                 '>
                                <div
                                    style={abroadPortalsDivStyle}
                                    onMouseEnter={abroadPortalsHandleHover}
                                    onMouseLeave={abroadPortalsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]              "></div>
                            </div>
                            <div className="card-body newContainer relative">
                                <h2 className="card-title text-white text-2xl">Try New Design</h2>
                                <p className='text-md  text-justify'>Abroad Portals is an Educational Consultancy Firm which offers services and consultancy related to studying abroad.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/abroadPortalsDetails'>
                                    <div className='bg-black border-2 border-green-700  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                                <div className='overlay'>
                                    <div className='content'>
                                        <h1 className='-mt-10 text-white font-serif uppercase font-bold text-xl'>Study in <span className='font-bold text-rose-500'>Canada</span> </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide> */}


                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    {/* Abroad Portals Card */}
                    <SwiperSlide>
                        <div className="mb-8 card card-compact bg-base-100 shadow-2xl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2 border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0  animation " data-aos='flip-left'>
                            {/* <figure><img src={abroadPortals} alt="Abroad" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0  mx-auto'>
                                <div
                                    style={abroadPortalsDivStyle}
                                    onMouseEnter={abroadPortalsHandleHover}
                                    onMouseLeave={abroadPortalsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px] "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Abroad Portals</h2>
                                <p className='text-md  text-justify'>Abroad Portals is an Educational Consultancy Firm which offers services and consultancy related to studying abroad.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/abroadPortalsDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto  hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>

                    
                    {/* Best Bikes Card */}
                    <SwiperSlide>
                        <div className="card card-compact bg-base-100 shadow-xxl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2 border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0  animation" data-aos='flip-left'>
                            {/* <figure><img src={bestBike1} alt="Bikes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0 lg:mx-0 mx-auto' >
                                <div style={bestBikesDivStyle}
                                    onMouseEnter={bestBikesHandleHover}
                                    onMouseLeave={bestBikesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom  lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]    "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Best Bikes</h2>
                                <p className='text-md  text-justify'>Best Bikes is a platform for buying and selling used bikes. It has a Multi user dashboard with different features.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/bestBikeDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>



                    {/* Doctors Portal Card */}
                    <SwiperSlide>
                        <div className="card card-compact bg-base-100 shadow-xxl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2 border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0  animation" data-aos='flip-left'>

                            <div className=' lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0 lg:mx-0 mx-auto' >
                                <div
                                    style={doctorsPortalDivStyle}
                                    onMouseEnter={doctorsPortalHandleHover}
                                    onMouseLeave={doctorsPortalHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom  lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]    "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Doctors Portal</h2>
                                <p className='text-md  text-justify'> It is an online Dental clinic for dental treatments. Such as: Teeth Whitening, Cavity Filling, Oral Surgery, etc.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/doctorsPortalDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto  hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>



                    {/* Job Hunter Card */}
                    <SwiperSlide className=''>
                        <div className="lg:h-[467px] md:h-[430px] sm:h-[449px] h-[449px] card card-compact  bg-base-100 shadow-2xl lg:mx-0 md:mx-[10px] sm:mx-[14px] mx-[14px] border-2  border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            <figure ><img src={jobHunter} alt="Creative" className=' transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Hunter</h2>
                                <p className='text-md text-justify'>Job Hunter is a portal for job seekers to find and apply to different jobs, applier can chat with employers and many more. </p>
                                <p className='lg:text-lg md:text-[17px] text-[15px] lg:text-center md:text-start sm:text-start text-start'>Tools: MERN, Redux, Firebase, Tailwind</p>
                                <Link to='/jobHunterDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>



                    {/* Job Nexus Card */}
                    <SwiperSlide className=''>
                        <div className="lg:h-[467px] md:h-[430px] sm:h-[449px] h-[449px] card card-compact  bg-base-100 shadow-2xl lg:mx-0 md:mx-[10px] sm:mx-[14px] mx-[14px] border-2  border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            <figure ><img src={jobNexus} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Nexus</h2>
                                <p className='text-md text-justify'>Job Nexus is a website for posting jobs by the recruiter and performing CRUD operation to the jobs he posted.</p>
                                <p className='lg:text-lg md:text-[15px] text-[15px] lg:text-center md:text-start sm:text-start text-start'>Tools: MERN, Redux, Firebase, Material UI</p>
                                <Link to='/jobNexusDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>




                    {/* Daily Tasks Card */}
                    <SwiperSlide className=''>
                        <div className="lg:h-[467px] md:h-[430px] sm:h-[449px] h-[449px] card card-compact  bg-base-100 shadow-2xl lg:mx-0 md:mx-[10px] sm:mx-[14px] mx-[14px] border-2  border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            <figure ><img src={dailyTasks} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Daily Tasks</h2>
                                <p className='text-md text-justify'>Daily Tasks is a task management website which helps an individual to manage and keep track his day to day tasks.</p>
                                <p className='lg:text-lg md:text-[15px] text-[15px] lg:text-center md:text-start sm:text-start text-start'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/dailyTasksDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>







                    {/* Creative Captures Card */}
                    <SwiperSlide className=''>
                        <div className="card card-compact  bg-base-100 shadow-2xl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2  border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            {/* <figure ><img src={creativeCaptures} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0  mx-auto' >
                                <div
                                    style={creativeCapturesDivStyle}
                                    onMouseEnter={creativeCapturesHandleHover}
                                    onMouseLeave={creativeCapturesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom  lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]    "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Creative Captures</h2>
                                <p className='text-md text-justify'>Creative Captures is an online Photography Service Review platform where user can add reviews of availed services </p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/creativeCapturesDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>



                    {/* Learner Academy Card */}
                    <SwiperSlide className=''>
                        <div className=" shadow-2xl card card-compact  bg-base-100 lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2  border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            {/* <figure><img src={learnerAcademy} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0  mx-auto ' >
                                <div
                                    style={learnerAcademyDivStyle}
                                    onMouseEnter={learnerAcademyHandleHover}
                                    onMouseLeave={learnerAcademyHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom  lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]    "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Learner Academy</h2>
                                <p className='text-md text-justify'>Learner Academy is an online platform which provides many courses related to computer science.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/learnerAcademyDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>




                    {/* Quiz Mania Card */}
                    <SwiperSlide className=''>
                        <div className="card card-compact  bg-base-100 shadow-2xl lg:mx-0 md:mx-4 sm:mx-6 mx-6 border-2 border-cyan-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='flip-left'>
                            {/* <figure><img src={quizmania} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' lg:w-[420px] lg:h-[227px] md:w-[333px] md:h-[170px] sm:w-[343px] sm:h-[189px] w-[343px] h-[189px] md:mx-0  mx-auto' >
                                <div
                                    style={quizManiaDivStyle}
                                    onMouseEnter={quizManiaHandleHover}
                                    onMouseLeave={quizManiaHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom  lg:w-[419px] lg:h-[229px] md:w-[327px] md:h-[177px] sm:w-[340px] sm:h-[176px] w-[340px] h-[176px]    "></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Quiz Mania</h2>
                                <p className='text-md text-justify'>Quiz Mania is an online quiz project that helps the students to take part in quizzes of different computer science courses.</p>
                                <p className='text-lg lg:text-center md:text-start sm:text-center text-center'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/quizManiaDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='Vie Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide>



                </Swiper>
            </div>
            <AllProjects></AllProjects>
        </div>
    );
};

export default Projects;